import React from 'react';
import { graphql } from 'gatsby';
import SEO from 'react-seo-component';
import Hero from '../components/hero';
import QAComponent from '../components/QAComponent';
import RichText from '../components/richText';
import Layout from '../components/layout'

function GenericPage(props) {
  const doc = props.data.prismic.pageByUID.edges.slice(0, 1).pop();
  const data = props.data.prismic.pageByUID.edges[0];
  const social = props.data.prismic.allSocials.edges.slice(0, 1).pop();

  if (!doc) return null;

  return (
    <Layout>
      <SEO
        title={data.node.hero_heading[0].text || 'Page'}
        titleTemplate={social.node.default_title || 'Leading Edge'}
        description={social.node.default_description || 'No copays, deductibles, prior authorizations, or pre-approvals. Welcome to Pharmacy Redefined.'}
        image={'src/images/eScript.logo.png'}
        pathname='https://www.escript360.com/'
        siteLanguage='en-US'
        siteLocale='en_us'
        twitterUsername='@escript360'
      />

      <Hero heading={data.node.hero_heading[0].text} size="slim" />
      
      <div className="generic-page">
        <div className="generic-page__inner">
          <RichText render={data.node.content} />
        </div>
      </div>

      {data.node.faq_list.length > 0 && (
        <QAComponent
          buttonUrl={data.node.faq_button_url}
          buttonText={data.node.faq_button_text}
          heading={data.node.faq_heading[0].text}
          data={data.node.faq_list}
          helpText={data.node.faq_help_text}
        />
      )}
    </Layout>
  );
}

export default GenericPage;

export const query = graphql`
  query getPage($uid: String) {
    prismic {
      pageByUID: allGeneric_static_pages(uid: $uid) {
        edges {
          node {
            _meta {
              uid
            }
            content
            faq_button_text
            faq_heading
            faq_help_text
            hero_heading
            title
            faq_list {
              q_a {
                ... on PRISMIC_Faqs {
                  question
                  answer
                  _meta {
                    uid
                  }
                }
              }
            }
          }
        }
      }
      allSocials {
        edges {
          node {
            default_description
            default_image
            site_name
            default_title
          }
        }
      }
    }
  }
`;
